<template>
  <div>
    <vs-button
      color="danger"
      type="gradient"
      @click="removepolygonall"
      style="margin-right: 10px"
      >delete all point</vs-button
    >
    <vs-button color="danger" type="gradient" @click="removepolygonlast"
      >delete last point</vs-button
    >
    <br />
    <br />

    <l-map
      style="height: 700px"
      :zoom="zoom"
      :center="center"
      @click="addpolygon"
    >
      <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
      <l-polygon :lat-lngs="polygon.latlngs" :color="polygon.color"></l-polygon>

      <l-marker :lat-lng="markerLatLng">
        <l-tooltip>
          <div>
            <div>
              Time stamp :
              {{ dataGPS.date.split("T")[0] }} {{ dataGPS.date.split("T")[1].split('.')[0] }}
            </div>
            <div>
              lat : {{dataGPS.lastdata.lat}}
            </div>
            <div>
              long : {{dataGPS.lastdata.long}}
            </div>
          </div>
        </l-tooltip>
      </l-marker>
    </l-map>
  </div>
</template>

<script>
import { LMap, LTileLayer, LPolygon, LTooltip } from "vue2-leaflet";

export default {
  components: {
    LMap,
    LTileLayer,
    LPolygon,
    LTooltip,
  },
  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 10,
      center: [13.8116717, 100.5650815],
      markerLatLng: [47.31322, -1.319482],
      polygon: {
        latlngs: [],
        color: "green",
      },
      dataGPS: {
        date: "2022-07-01T06:17:40.000Z",
        lastdata: {
          alarm: 0,
          angular: 147,
          battery: 97,
          lat: 0,
          long: 0,
          rssi: -46,
          x: 0.0201416015625,
          y: 3.976318359375,
          z: 3.9505615234375,
        },
      },
      timeout: null,
    };
  },
  async mounted() {
    this.getGPS();
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
  methods: {
    addpolygon(event) {
      console.log("click", event);
      this.polygon.latlngs.push([event.latlng.lat, event.latlng.lng]);
    },
    removepolygonall() {
      this.polygon.latlngs = [];
    },
    removepolygonlast() {
      this.polygon.latlngs.splice(-1);
    },
    async getGPS() {
      try {
        let res = await this.$API.get("getgpsdemo");
        console.log("GPS", res.data);
        // this.items_box = res.data;
        this.center = [res.data.lastdata.lat, res.data.lastdata.long];
        this.markerLatLng = [res.data.lastdata.lat, res.data.lastdata.long];
        this.dataGPS = res.data;
        this.timeout = setTimeout(async () => {
          await this.getGPS();
        }, 1000 * 30);
      } catch (error) {}
    },
  },
};
</script>

<style>
</style>